import React, {useEffect, useState} from 'react'
import {createOTP_contactnumber, verify_contactnumber} from './Update_API'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import Swal from 'sweetalert2'
import {Modal} from 'react-bootstrap'

const VerifyContactNumber = ({
  contactNo,
  getProfileData,
  setModalContactIsOpen,
  modalContactIsOpen,
}: any) => {
  const [getShowData, setGetShowData] = useState(false)
  const [c_time, setC_time] = useState(0)
  const [label, setLabel] = useState('Send OTP')
  const [contactOTPSuccess, setContactOTPSuccess] = useState(false)
  const [error, setError] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const closeModalContactNumber = (event: any) => {
    setModalContactIsOpen(false)
    setGetShowData(false)
    setLabel('Send OTP')
    setC_time(0)
    setError('')
    formik.resetForm()
  }
  const initialValues = {
    Contact_OTP: '',
  }
  const validationSchema = Yup.object().shape({
    Contact_OTP: Yup.number()
      .typeError('OTP must be a number')
      .positive('OTP must be a positive number')
      .integer('OTP must be an integer')
      .min(1000, 'OTP must be at least 4 digits')
      .max(9999, 'OTP cannot be more than 4 digits')
      .required('OTP is required'),
  })
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      verify_contact_number('', parseInt(values.Contact_OTP, 10), contactNo)
    },
  })

  // timer to verify contact number otp
  useEffect(() => {
    let intervalId: NodeJS.Timeout
    if (c_time > 0)
      intervalId = setInterval(() => {
        setC_time((prevTime) => prevTime - 1)
      }, 1000)
    return () => clearInterval(intervalId)
  }, [c_time])

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }, [error])

  // function to create contact number otp
  async function createotp_contactnumber(contactNo: string) {
    const type = 'contact_number'
    const {data: res} = await createOTP_contactnumber(type, contactNo)
    if (res.code === '200') {
      setGetShowData(true)
      setLabel('Resend OTP')
      setC_time(120)
      setContactOTPSuccess(true)
    } else {
      setContactOTPSuccess(false)
      setError(`${res.msg.charAt(0).toUpperCase() + res.msg.slice(1)}: ${res.msg_details}`)
      // Swal.fire({
      //   position: 'center',
      //   icon: 'error',
      //   title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
      //   text: res.msg_details,
      //   allowOutsideClick: true,
      // })
    }
  }

  // function to verify contact number otp
  async function verify_contact_number(type: string, otp: number, contact_data: string) {
    setLoading(true)
    setError('')
    try {
      if (contactOTPSuccess) {
        type = 'contact_number'
        const {data: res} = await verify_contactnumber(type, otp, contact_data)
        if (res.code === '200') {
          setLoading(false)
          setModalContactIsOpen(false)
          setGetShowData(false)
          setLabel('Send OTP')
          setC_time(0)
          getProfileData()
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
            text: res.msg_details,
            allowOutsideClick: true,
          })
        } else {
          setLoading(false)
          setError(`${res.msg.charAt(0).toUpperCase() + res.msg.slice(1)}: ${res.msg_details}`)
          // Swal.fire({
          //   position: 'center',
          //   icon: 'error',
          //   title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          //   text: res.msg_details,
          //   allowOutsideClick: true,
          // })
        }
      }
    } catch (error) {}
  }
  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={modalContactIsOpen}
      onHide={() => setModalContactIsOpen(false)}
      backdrop={true}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className='modal-content'>
          <div className='modal-header pt-5 pb-5'>
            <h5 className='modal-title'>Verify Contact Number</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              aria-label='Close'
              onClick={closeModalContactNumber}
            >
              <i className='bi bi-x-lg' />
            </div>
          </div>
          {/* error msg after failed apis */}
          {error && (
            <div className='h-20px d-flex justify-content-center' style={{backgroundColor: 'red'}}>
              <div className='fv-help-block' style={{color: 'white'}}>
                {error}
              </div>
            </div>
          )}
          <div className='modal-body pb-4'>
            <p>
              A 4-digit OTP will be send to <strong>{contactNo}</strong>
            </p>

            {getShowData && (
              <>
                <input
                  {...formik.getFieldProps('Contact_OTP')}
                  name='Contact_OTP'
                  className='form-control form-control-solid'
                  placeholder='Enter OTP'
                />
                <div className='h-20px'>
                  {formik.touched.Contact_OTP && formik.errors.Contact_OTP && (
                    <div className='fv-help-block color-red'>{formik.errors.Contact_OTP}</div>
                  )}
                </div>
              </>
            )}

            <div className='d-flex align-items-center justify-content-between'>
              <div>
                {getShowData && (
                  <div>
                    Time left: {`${String(Math.floor(c_time / 60))}`.padStart(2, '0')}:
                    {`${String(c_time % 60)}`.padStart(2, '0')}
                  </div>
                )}
              </div>
              <button
                onClick={async (e) => {
                  e.preventDefault()
                  await createotp_contactnumber(contactNo)
                }}
                className={`btn ${(label === 'Resend OTP' && c_time > 0)? 'btn-light':'btn-primary'}`}
                disabled={label === 'Resend OTP' && c_time > 0}
              >
                {label}
              </button>
            </div>
          </div>

          {getShowData && (
            <div className='modal-footer pt-2 pb-2 mb-0 d-flex justify-content-center'>
              <button type='submit' className='btn btn-primary'>
                {loading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Processing...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  'Verify'
                )}
              </button>
            </div>
          )}
        </div>
      </form>
    </Modal>
  )
}

export default VerifyContactNumber
